<template>
  <!-- Content -->
  <div class="card1 mb-3">
    <div class="card-body">
      <div class="row p-sm-3 p-0">
        <div class="col-md-6 mb-md-0 mb-4">
          <div class="d-flex svg-illustration mb-4 gap-2">
          </div>
          <p class="mb-1 fw-bold">LAMODA VIETNAM COMPANY LIMITED</p>
          <p class="mb-1">Ho Chi Minh City, Vietnam</p>
          <p class="mb-0">+84 (0) 394 577 366</p>
        </div>
        <div class="col-md-6">
            <dl class="row mb-2">
            <dt class="col-sm-5 mb-2 mb-sm-0 text-md-end mt-2">
              <span class="h5 text-capitalize mb-0 text-nowrap">Invoice Code</span>
            </dt>
            <dd class="col-sm-7 d-flex justify-content-md-end">
              <div class="w-px-250">
                <input type="text" 
                  class="form-control disabled" 
                  v-model="stateData.invoice_code"
                  disabled
                >
              </div>
            </dd>
            <dt class="col-sm-5 mb-2 mb-sm-0 text-md-end mt-2">
              <span class="fw-normal">Contract Code</span>
            </dt>
            <dd class="col-sm-7 d-flex justify-content-md-end">
              <div class="w-px-250">
                <VueMultiselect 
                  v-model="contractSelected"
                  :options="list_search_contract" 
                  placeholder="Search product name, Code" 
                  label="contract_code" 
                  @search-change="asyncFind"
                  @remove="removeSelectedContract"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :show-labels="false"
                />
              </div>
            </dd>
            <dt class="col-sm-5 mb-2 mb-sm-0 text-md-end mt-2">
                <span class="fw-normal">Issued Date</span>
            </dt>
            <dd class="col-sm-7 d-flex justify-content-md-end">
              <div class="w-px-250">
                <flat-pickr 
                  v-model="stateData.invoice_date" 
                  :config="calendarConfig" 
                  placeholder="Select a date" 
                  name="contract-date" 
                  class="form-control">
                </flat-pickr>
              </div>
            </dd>
            </dl>
        </div>
      </div>
      <hr class="my-4 mx-n4">
      <div class="row p-sm-0 p-0">
        <div class="col-md-6 col-sm-6 col-12" v-if="stateData.supplierInfo.id">
          <h6 class="pb-2 fw-bold">Supplier Information</h6>
          <div class="alert alert-primary mt-1" role="alert">
            <div class="row">
              <div class="mb-2">
                <span class="fw-bold me-3">{{ stateData.supplierInfo.partner_name }}</span>
                <div class="mt-2">
                  <span class="fw-bold me-3">Address:</span>
                  {{ stateData.supplierInfo.address +" "+ stateData.supplierInfo.ward_name +" "+ 
                    stateData.supplierInfo.district_name +" "+ stateData.supplierInfo.city_name +" "+ stateData.supplierInfo.country}}
                  {{ stateData.supplierInfo.zipcode ? ", zipcode: " + stateData.supplierInfo.zipcode : "" }}
                </div>
                <div class="mt-3">
                  <span class="fw-bold me-3">Payment method:</span>
                  {{ getPaymentName(stateData.supplierInfo.payment_method) +" "+ stateData.supplierInfo.term +" days "+ getClosingTime(stateData.supplierInfo.closing_time) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" v-if="stateData.customerInfo.id">
          <h6 class="pb-2 fw-bold">Customer Information</h6>
          <div class="alert alert-warning mt-1" role="alert">
            <div class="row">
              <div class="mb-2">
                <span class="fw-bold me-3">{{ stateData.customerInfo.partner_name }}</span>
                <div class="mt-2">
                  <span class="fw-bold me-3">Address:</span>
                  {{ stateData.customerInfo.address +" "+ stateData.customerInfo.ward_name +" "+ 
                    stateData.customerInfo.district_name +" "+ stateData.customerInfo.city_name +" "+ stateData.customerInfo.country}}
                  {{ stateData.customerInfo.zipcode ? ", zipcode: " + stateData.customerInfo.zipcode : "" }}
                </div>
                <div class="mt-3">
                  <span class="fw-bold me-3">Payment method:</span>
                  {{ getPaymentName(stateData.customerInfo.payment_method) +" "+ stateData.customerInfo.term +" days "+ getClosingTime(stateData.customerInfo.closing_time) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4" v-if="stateData.supplierInfo.id">
          <label class="form-label">Purchase Exchange Rates</label>
          <cleave class="form-control text-end" 
            placeholder="1.00"
            v-model="stateData.buy_exchange_rates"
            :options="cleaveOptions.ex_rate"
            disabled
          />
        </div>
        <div class="col-md-2 col-sm-2" v-if="stateData.supplierInfo.id"></div>
        <div class="col-md-4 col-sm-4" v-if="stateData.customerInfo.id">
          <label class="form-label">Sale Exchange Rates</label>
          <cleave class="form-control text-end" 
            placeholder="1.00"
            v-model="stateData.sell_exchange_rates"
            :options="cleaveOptions.ex_rate"
            disabled
          />
        </div>
      </div>
      <hr class="mx-n4" v-if="stateData.contract_id">
      <div class="card-body">
        <div class="row" v-if="stateData.contract_id">
          <div class="col col-md-4 text-start mb-3">
            <button type="button" 
              class="btn btn-warning me-3" 
              @click="openModalQuantity"
              v-if="csv_content"
            >
              Check Quantity Support
            </button>
          </div>
          <div class="col-md-8 text-end mb-3">
            <button type="button" 
              class="btn btn-primary me-3"
              onclick="document.getElementById('file_upload').click()"
            >
              Upload Quantity
            </button>
            <input 
              class="form-control d-none" 
              type="file" 
              accept=".csv"
              id="file_upload"
              name="file-upload"
              @change="handleFileUpload($event)"
            >
            <button type="button" class="btn btn-primary me-3"
              @click="downloadSampleQuanity"
            >
              Download Sample File
            </button>
            <div class="btn-group" role="group">
              <button type="button" 
                class="btn"
                :class="{'btn-outline-secondary': !activeViewListBtn, 'btn-secondary': activeViewListBtn}"
                @click="viewItemList"
              >
                Item View
              </button>
              <button type="button" 
                class="btn"
                :class="{'btn-outline-secondary': !activeViewTableBtn, 'btn-secondary': activeViewTableBtn}"
                @click="viewItemTable"
              >
                Table View
              </button>
            </div>
          </div>
        </div>
        <template v-if="stateData.list_products.length > 0">
          <div class="d-flex border rounded position-relative mb-3" v-for="(product, key) in stateData.list_products" :key="key">
            <!-- <shipment-product-detail
              :product="product"
              :index="key"
              @changeAmountValue="changeGrandTotalAmount"
            >
            </shipment-product-detail> -->
            <shipment-product-detail
              :product="product"
              :index="key"
              @product-changed="onProductChanged"
              :item_view="activeViewListBtn"
            >
            </shipment-product-detail>
          </div>
        </template> 
        <!-- Grand Total Amount -->
        <div class="row col-md-12 m-0 mt-5" v-if="stateData.contract_id">
          <div class="col-md-5 d-flex justify-content-end" style="margin-left: 5rem">
            <div class="invoice-calculations">
              <div class="d-flex justify-content-between mb-4">
                <span class="fw-bold w-px-200"></span>
                <span class="fw-bold">PURCHASE</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Subtotal:</span>
                <span class="fw-semibold">{{ stateData.buy_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.sub_total_buy) }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Tax:</span>
                <span class="fw-semibold">{{ stateData.buy_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.tax_total_buy) }}</span>
              </div>
              <hr>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Grand Total:</span>
                <span class="fw-semibold">{{ stateData.buy_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.grand_total_buy_price) }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Grand Total in VND (-Tax)</span>
                <span class="fw-semibold">VND&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.grand_total_buy_vnd) }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 d-flex justify-content-end" style="margin-left:-1.7rem; text-align: right;">
            <div class="invoice-calculations">
              <div class="d-flex justify-content-between mb-4">
                <span class="fw-bold w-px-200"></span>
                <span class="fw-bold">SELL</span>
              </div>
              <div class="d-flex1 justify-content-between mb-2">
                <span class="fw-semibold">&nbsp;</span>
                <span class="fw-semibold">{{ stateData.sell_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.sub_total_sell) }}</span>
              </div>
              <div class="d-flex1 justify-content-between mb-2">
                <span class="fw-semibold">&nbsp;</span>
                <span class="fw-semibold">{{ stateData.sell_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.tax_total_sell) }}</span>
              </div>
              <hr>
              <div class="d-flex1 justify-content-between mb-2">
                <span class="fw-semibold">&nbsp;</span>
                <span class="fw-semibold">{{ stateData.sell_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.grand_total_sell_price) }}</span>
              </div>
              <div class="d-flex1 justify-content-between mb-2">
                <span class="fw-semibold">&nbsp;</span>
                <span class="fw-semibold">VND&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.grand_total_sell_vnd) }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-5">
            <span class="fw-bold me-2">GRAND PURCHASE AMOUNT: </span> 
            <span class="fw-bold text-primary">{{ getFormatCurrencyText(stateData.grand_total_buy_text) }}&nbsp;{{ stateData.buy_currency }}</span>
          </div>
          <div class="col-md-12 mt-3">
            <span class="fw-bold me-2">GRAND SELL AMOUNT: </span> 
            <span class="fw-bold text-warning">{{ getFormatCurrencyText(stateData.grand_total_sell_text) }}&nbsp;{{ stateData.sell_currency }}</span>
          </div>
        </div>
        <!-- / Grand Total Amount -->
      </div>
      <hr class="my-4" v-if="stateData.contract_id">
      <div class="row" v-if="stateData.contract_id">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Date of Inbound</label>
            <flat-pickr 
              v-model="stateData.inbound_date" 
              :config="calendarConfig" 
              placeholder="Select a date" 
              name="contract-date" 
              class="form-control">
            </flat-pickr>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Date of Shipment</label>
            <flat-pickr 
              v-model="stateData.shipment_date" 
              :config="calendarConfig" 
              placeholder="Select a date" 
              name="contract-date" 
              class="form-control">
            </flat-pickr>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Country of Origin</label>
            <input type="text" 
              class="form-control" 
              v-model="stateData.country_origin"
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Means of Transport</label>
            <input type="text" 
              class="form-control"
              v-model="stateData.mean_transport"
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">HAWB NO</label>
            <input type="text" 
              class="form-control"
              v-model="stateData.hawb_no"
            >
          </div>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Port of Loading</label>
            <input type="text" 
              class="form-control"
              v-model="stateData.port_landing"
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Port of Discharge</label>
            <input type="text" 
              class="form-control"
              v-model="stateData.port_discharge"
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Upload Supplier PXK</label>
            <div class="position-relative">
              <input 
                class="form-control" 
                type="file" 
                accept=".jpg, .png, .pdf"
                name="file_1"
                @change="onFileChange"
              >
            </div>
            <div class="mt-2" v-if="isUploadSuccess_1">
              <span class="fw-bold text-success">The image is uploaded to server successfully.</span>
            </div>
            <div class="mt-2" v-if="isError_1">
              <span class="fw-bold text-danger">The image isn't still uploaded to server.</span>
            </div>
            <!-- Show Image 1 -->
            <div class="mb-3 col-md-12">
              <div class="p-4 category-left1 category-top1" v-for="(image, key) in images_1" :key="key">
                <img class="card-img-top card-img-bottom" :ref="'image_1'">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Upload Input VAT</label>
            <div class="position-relative">
              <input 
                class="form-control" 
                type="file" 
                accept=".jpg, .png, .pdf"
                name="file_2"
                @change="onFileChange"
              >
            </div>
            <div class="mt-2" v-if="isUploadSuccess_2">
              <span class="fw-bold text-success">The image is uploaded to server successfully.</span>
            </div>
            <div class="mt-2" v-if="isError_2">
              <span class="fw-bold text-danger">The image isn't still uploaded to server.</span>
            </div>
            <!-- Show Image 2 -->
            <div class="mb-3 col-md-12">
              <div class="p-4" v-for="(image, key) in images_2" :key="key">
                <img class="card-img-top card-img-bottom" :ref="'image_2'">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Upload PXK Lamoda</label>
            <div class="position-relative">
              <input 
                class="form-control" 
                type="file" 
                accept=".jpg, .png, .pdf"
                name="file_3"
                @change="onFileChange"
              >
            </div>
            <div class="mt-2" v-if="isUploadSuccess_3">
              <span class="fw-bold text-success">The image is uploaded to server successfully.</span>
            </div>
            <div class="mt-2" v-if="isError_3">
              <span class="fw-bold text-danger">The image isn't still uploaded to server.</span>
            </div>
            <!-- Show Image 3 -->
            <div class="mb-3 col-md-12">
              <div class="p-4" v-for="(image, key) in images_3" :key="key">
                <img class="card-img-top card-img-bottom" :ref="'image_3'">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="note" class="form-label fw-semibold">Upload output VAT</label>
            <div class="position-relative">
              <input 
                class="form-control" 
                type="file" 
                accept=".jpg, .png, .pdf"
                name="file_4"
                @change="onFileChange"
              >
            </div>
            <div class="mt-2" v-if="isUploadSuccess_4">
              <span class="fw-bold text-success">The image is uploaded to server successfully.</span>
            </div>
            <div class="mt-2" v-if="isError_4">
              <span class="fw-bold text-danger">The image isn't still uploaded to server.</span>
            </div>
            <!-- Show Image 4 -->
            <div class="mb-3 col-md-12">
              <div class="p-4" v-for="(image, key) in images_4" :key="key">
                <img class="card-img-top card-img-bottom" :ref="'image_4'">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="mb-3 col-sm-6">
          <router-link to="/shipment" data-i18n="Add Product" class="btn btn-outline-secondary w-45">
            <i class='bx bx-arrow-back' ></i>
            Back To List
          </router-link>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal modal-transparent show fade" v-if="isLoading" id="basicModal" style="display: block;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <rise-loader :color="color" :size="size" style="text-align:center;"></rise-loader>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Check Quantity -->
    <div class="modal show" id="backDropModal" data-bs-backdrop="static" style="display: block;" v-if="isModalQuantity">
      <div class="modal-dialog">
        <form class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="backDropModalTitle">Modal Check & Confirm Quantity</h5>
            <button type="button" class="btn-close" 
              data-bs-dismiss="modal"
              @click="closeModalQuantity"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row px-3">
              <div class="col-sm-4 mb-3 px-0" style="font-size:0.8rem;">
                <ul class="list-group list-group-flush mb-31">
                  <li class="list-group-item d-flex justify-content-between align-items-center active">
                    <span class="fw-bold">PRODUCT CODE</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between align-items-center fee-border p-1"
                    v-for="(prod, key) in csv_content.data" :key="key"
                  >
                    <span class="fw-bold">{{ prod.product_code }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4 mb-3 px-0" style="font-size:0.8rem;">
                <ul class="list-group list-group-flush mb-31">
                  <li class="list-group-item d-flex justify-content-between align-items-center active">
                    <span class="fw-bold">QUANTITY IN</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between align-items-center p-0"
                    v-for="(qtt_in, key) in csv_content.data" :key="key"
                  >
                    <div class="col-sm-12">
                      <cleave
                        class="form-control text-end cost-input"
                        placeholder="0"
                        v-model="qtt_in.quantity_in"
                        :options="cleaveOptions.fee"
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4 mb-3 px-0" style="font-size:0.8rem;">
                <ul class="list-group list-group-flush mb-31">
                  <li class="list-group-item d-flex justify-content-between align-items-center active">
                    <span class="fw-bold">QUANTITY OUT</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between align-items-center p-0"
                    v-for="(qtt_out, key) in csv_content.data" :key="key"
                  >
                    <div class="col-sm-12">
                      <cleave
                        class="form-control text-end cost-input"
                        placeholder="0"
                        v-model="qtt_out.quantity_out"
                        :options="cleaveOptions.fee"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-label-secondary" 
              data-bs-dismiss="modal" 
              @click="closeModalQuantity"
            >Close</button>
            <button type="button" 
              class="btn btn-primary"
              @click="applyNewQuantity"
            >Apply</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- / Content -->
</template>

<script>
import { mapState } from "vuex";
import flatPickr from 'vue-flatpickr-component';
import { configs } from '@/config/calendar.js';
import useValidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import ShipmentProductDetail from "./ShipmentProductDetail.vue";
// import showConfirmDeleteAlert from "../../helper/error.js"
// import {Converter} from "any-number-to-words";
import VueMultiselect from 'vue-multiselect'
import {errorAlert} from "../../helper/error.js"
import { CURRENCY_EXCHANGE, CLOSING_TIME, TAX_CONFIG, SHIPMENT_CSV_HEADER, PAYMENT_METHOD } from "../../config/common.js"
import _ from 'lodash';
import RiseLoader from 'vue-spinner/src/RiseLoader.vue';
import { saveAs } from 'file-saver';
import axios from 'axios';


export default {
  name: 'ShipmentAdd',
  components: {
    flatPickr,
    ShipmentProductDetail,
    VueMultiselect,
    RiseLoader 
  },
  data() {
    return {
      v$: useValidate(),
      calendarConfig: configs,
      color: '#696cff',
      size: '20px',
      isLoading: false,
      isModalQuantity: false,
      domain: process.env.VUE_APP_DOMAIN_FILE_SERVER,
      images: [],
      images_1: [],
      images_2: [],
      images_3: [],
      images_4: [],
      isError_1: false,
      isError_2: false,
      isError_3: false,
      isError_4: false,
      isUploadSuccess_1: false,
      isUploadSuccess_2: false,
      isUploadSuccess_3: false,
      isUploadSuccess_4: false,
      page:1,
      list_search_contract: [],
      contractSelected: null,
      // subTotalBuyPrice: null,
      // subTotalSellPrice: null,
      subTotalBuyPriceWithTax: null,
      subTotalSellPriceWithTax: null,
      grandTotalBuyTax: null,
      grandTotalSellTax: null,
      grandTotalBuyPriceVND: null,
      grandTotalSellPriceVND: null,
      productInfo: {
        product_id: "",
        product_code: "",
        quantity_in: null,
        quantity_out: null,
        buy_price: null,
        sell_price: null,
        purchase_total_amount: null,
        sell_total_amount: null,
        sku: null,
        tax_1: {
          id: null,
          name: "",
          value: null,
          is_display: true, 
        },
        tax_2: {
          id: null,
          name: "",
          value: null,
          is_display: false
        },
        tax_3: {
          id: null,
          name: "",
          value: null,
          is_display: false
        }
      },
      cleaveOptions: {
        ex_rate: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2
        },
        fee: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalScale: 2
        }
      },
      csv_file: '',
      csv_content: null,
      csv_errors: [],
      activeViewListBtn: true,
      activeViewTableBtn: false,
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.shipmentAdd.stateData
    }),
    currencyOptions() {
      return CURRENCY_EXCHANGE;
    },
    taxOptions() {
      return TAX_CONFIG;
    },
    CSV_HEADER () {
      return SHIPMENT_CSV_HEADER;
    },
    paymentMethodOptions() {
      return PAYMENT_METHOD;
    }
  },
  watch: {
    async "contractSelected" (newVal) {
      if (!newVal) return;

      const { invoice_code, invoice_code_id } = this.stateData;

      try {
        this.isLoading = true;
        
        // Reset data related to shipment data
        this.$store.dispatch('shipmentAdd/resetState');

        // restore invoice
        this.stateData.invoice_code = invoice_code;
        this.stateData.invoice_code_id = invoice_code_id;

        // Load toàn bộ dữ liệu liên quan contract
        this.stateData.contract_id = newVal.id;
        await this.$store.dispatch('shipmentAdd/loadContractShipmentData', newVal);

        // Handle exchange rate
        this.stateData.buy_exchange_rates = Number(this.stateData.buy_exchange_rates).toFixed(2);
        this.stateData.sell_exchange_rates = Number(this.stateData.sell_exchange_rates).toFixed(2);

        // Re calculate for totals amount (handle in store action)
        // this.$store.dispatch('shipmentAdd/reCalculateGrandTotal');
      }
      catch (error) {
        console.error(error);
        errorAlert(
          'error',
          'Network Error',
          'Can not load Contract information'
        );
      } finally {
        this.isLoading = false;
      }
    },
    "stateData.inbound_date" (newVal) {
      this.stateData.receiving_voucher_date = newVal;
    },
    "stateData.shipment_date" (newVal) {
      this.stateData.delivery_voucher_date = newVal;
      this.stateData.invoice_date = newVal;
    },
    // "stateData.buy_exchange_rates"() {
    //   this.$store.dispatch("shipmentAdd/reCalculateGrandTotal");
    // },
    // "stateData.sell_exchange_rates"() {
    //   this.$store.dispatch("shipmentAdd/reCalculateGrandTotal");
    // }
  },
  beforeCreate() {
    // this.$store.dispatch('shipmentAdd/resetState');
  },
  created() {
    // Khởi tạo debounce cho recalc (dùng cho toàn component)
    this.recalcDebounced = _.debounce(() => {
      this.$store.dispatch("shipmentAdd/reCalculateGrandTotal");
    }, 300);

    // Handling get contract information to show supplier and customer
    let query_param = this.$router.currentRoute._value.query;
    if (!_.isEmpty(query_param)){
      if (_.has(query_param, "invoice_code")){
        if(this.stateData.contract_id) {
          this.asyncFind(this.stateData.contract_code);
        }

        this.isLoading = true;
        this.$store.dispatch('shipmentAdd/searchInvoiceRegByCode', {"page": 1, "searchKey": query_param.invoice_code})
        .then(
          () => { 
            this.isLoading = false;
            if (!this.stateData.invoice_code_id) {
              return;
            }
          },
          (error) => {
            this.isLoading = false;
            console.log(error);
            errorAlert("error", "Network Error",'Can not get Contract Code data!');
          }
        );
      }
      else {
        return;
      }
    }
    else {
      return;
    }
  },
  mounted() {
  },
  methods: {
    onFileChange(e) {
      let selectedFiles = e.target.files;
      if (selectedFiles.length > 0) {
        let index = 0;
        if(e.target.name == "file_1") {
          this.images_1 = [];
          this.images_1.push(selectedFiles[0]);
          this.stateData.file_link_1 = selectedFiles[0].name;
          index = 1;
          this.isError_1 = false;
        }
        if(e.target.name == "file_2") {
          this.images_2 = [];
          this.images_2.push(selectedFiles[0]);
          this.stateData.file_link_2 = selectedFiles[0].name;
          index = 2;
          this.isError_2 = false;
        }
        if(e.target.name == "file_3") {
          this.images_3 = [];
          this.images_3.push(selectedFiles[0]);
          this.stateData.file_link_3 = selectedFiles[0].name;
          index = 3;
          this.isError_3 = false;
        }
        if(e.target.name == "file_4") {
          this.images_4 = [];
          this.images_4.push(selectedFiles[0]);
          this.stateData.file_link_4 = selectedFiles[0].name;
          index = 4;
          this.isError_4 = false;
        }
        
        let reader = new FileReader();
        reader.onload = () => {
          this.$refs["image_"+index][0].src = reader.result;
        };
        reader.readAsDataURL(selectedFiles[0]);

        // Handling upload file onto server
        this.submitImageFile(e.target.name, selectedFiles[0]);
      }
    },
    submitImageFile(el_name, file_upload) {
      let formData = new FormData();

      formData.append("files", file_upload);
      formData.append("el_name", el_name);
      formData.append("contract_code", this.stateData.contract_code);
      formData.append("invoice_code", this.stateData.invoice_code);

      this.$store.dispatch('shipmentAdd/uploadShipmentFile', formData).then(
        () => {
          if(el_name == "file_1") {
            this.isUploadSuccess_1 = true;
            this.isError_1 = false;
          }
          if(el_name == "file_2") {
            this.isUploadSuccess_2 = true;
            this.isError_2 = false;
          }
          if(el_name == "file_3") {
            this.isUploadSuccess_3 = true;
            this.isError_3 = false;
          }
          if(el_name == "file_4") {
            this.isUploadSuccess_4 = true;
            this.isError_4 = false;
          }
        },
        error => {
          console.log(error);
          if(el_name == "file_1") {
            this.isUploadSuccess_1 = false;
            this.isError_1 = true;
          }
          if(el_name == "file_2") {
            this.isUploadSuccess_2 = false;
            this.isError_2 = true;
          }
          if(el_name == "file_3") {
            this.isUploadSuccess_3 = false;
            this.isError_3 = true;
          }
          if(el_name == "file_4") {
            this.isUploadSuccess_4 = false;
            this.isError_4 = true;
          }

          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to upload image !'
          });
        }
      );
    },
    asyncFind(query) {
      if (query.length < 3) return;
      
      // Get List contract belong to input value
      this.$store.dispatch('shipmentAdd/searchContract', {"page": this.page, "searchKey":  query})
      .then(
        (response) => { 
          this.list_search_contract = response.listItems;
          if(this.stateData.contract_id) {
            this.contractSelected = this.list_search_contract.filter(item => {
              return item.id == this.stateData.contract_id;
            })[0];
          }
        },
        (error) => {
          console.log(error);
          errorAlert("error", "Network Error",'Can not get search data!');
        }
      );
    },
    removeSelectedContract() {
      let invoice_code_id = this.stateData.invoice_code_id;
      let invoice_code = this.stateData.invoice_code;
      this.$store.dispatch('shipmentAdd/resetState');
      this.stateData.invoice_code_id = invoice_code_id;
      this.stateData.invoice_code = invoice_code;
    },
    getFormatCurrency(value) {
      return Intl.NumberFormat().format(value);
    },
    getFormatCurrencyText(value) {
      return value.toUpperCase();
    },
    getClosingTime(close_time_id) {
      let query = CLOSING_TIME.filter(item => item.id == close_time_id);
      return query[0].name
    },
    getPaymentName(val) {
      let query = this.paymentMethodOptions.filter((item) => {
        return item.value == val;
      });
      return query.length > 0 ? query[0].name_en : ""
    },
    openModalQuantity() {
      this.isModalQuantity = true;
    },
    closeModalQuantity() {
      this.isModalQuantity = false;
    },
    handleFileUpload(event){
      this.csv_file = event.target.files[0];
      this.parseFile(event);
    },
    parseFile (event){
      this.$papa.parse(this.csv_file, {
        header: true,
        skipEmptyLines: true,
        complete: function(results) {
          this.csv_errors.length = 0;
          this.csv_content = results;
          this.csv_content.data.forEach(itemObject => {
            let error_obj = {} 
            Object.keys(itemObject).forEach(item => {
              let result = this.checkValidateData(item, itemObject[item], this.csv_content.data);
              console.log("result: ", result);
              if (!result) {
                error_obj[item] = itemObject[item];
              }
            });
            this.csv_errors.push(error_obj);
          });
          this.checkHasErrors(this.csv_errors).then(
            () => {
              // Handle change quantity value of current list product
              if (this.csv_errors.length == 0){
                this.stateData.list_products.forEach(prodItem => {
                  this.csv_content.data.forEach(csvItem => {
                    if (prodItem.product_code == csvItem.product_code){
                      prodItem.quantity_in = csvItem.quantity_in;
                      prodItem.quantity_out = csvItem.quantity_out;
                    }
                  });
                });
              } 
              else {
                let error_messages = "";
                for (let errorItem of this.csv_errors) {
                  Object.keys(errorItem).forEach(item => {
                    error_messages += item + ": " + errorItem[item] + "<br/>";
                  });
                  if (error_messages !== "") {
                    break;
                  }
                }
                errorAlert("error","Invalid Data Error", error_messages);
              }
            }
          );
          
          event.target.value = "";
        }.bind(this)
      });
    },
    checkValidateData(field_name, value, array) {
      let result = true;
      if (field_name == this.CSV_HEADER[0].code){
        result = this.checkNumber(value);
      }
      else if (field_name == this.CSV_HEADER[1].code){
        result = this.checkProductCodeFormat(value);
        if (result) {
          result = this.checkDuplicatedProductCode(field_name, value, array);
        }
        if (result){
          result = this.checkProductExistedInList(value);
        }
      }
      else if (field_name == this.CSV_HEADER[2].code){
        result = this.checkNumber(value);
      }
      else if (field_name == this.CSV_HEADER[3].code) {
        result = this.checkNumber(value);
      }
      else {
        return false;
      }

      if (this.checkIsEmpty(value)) {
        return false;
      }

      return result;
    },
    checkIsEmpty(value) {
      return !value;
    },
    checkNumber(value) {
      return !isNaN(value) && _.isInteger(parseInt(value));
    },
    checkProductCodeFormat(value) {
      // SB-PTSH230210-01
      let pattern =/^([A-Z]{2})-([A-Z,0-9]{10,12})-([0-9]{2})$/;
      return pattern.test(value);
    },
    checkDuplicatedProductCode(field_name, value, array) {
      let result = array.filter(item => {
        return item[field_name] == value;
      });
      return result.length == 1;
    },
    checkProductExistedInList( value) {
      if (this.stateData.list_products.length == 0) return false;

      let result = this.stateData.list_products.filter(item => {
        return item.product_code == value;
      });
      return result.length > 0;
    },
    async checkHasErrors(array_error) {
      if (array_error.length > 0) {
        let check = array_error.filter(item => {
          return Object.keys(item).length > 0;
        });
        if (check.length == 0) {
          array_error.length = 0;
        }
      }
      return array_error;
    },
    applyNewQuantity() {
      this.stateData.list_products.forEach(prodItem => {
        this.csv_content.data.forEach(csvItem => {
          if (prodItem.product_code == csvItem.product_code){
            prodItem.quantity_in = csvItem.quantity_in;
            prodItem.quantity_out = csvItem.quantity_out;
          }
        });
      });
      this.closeModalQuantity();
    },
    downloadSampleQuanity() {
      let url = "/upload/sample/sample_shipment_quantity.csv"
      axios
        .get(this.domain+url, {responseType: 'blob'})
        .then(response => {
            saveAs(response.data, "sample_shipment_quantity.csv");
        })
    },
    onProductChanged() {
      this.recalcDebounced();
    },
    viewItemList() {
      console.log("viewItemList");
      this.activeViewListBtn = true;
      this.activeViewTableBtn = false;
    },
    viewItemTable() {
      console.log("viewItemTable");
      this.activeViewListBtn = false;
      this.activeViewTableBtn = true;
    }
  },
  validations() {
    return {
      stateData: {
        invoice_code: {
          required: helpers.withMessage('INVOICE CODE can not be empty', required)
        }
      }
    }
  }
}
</script>

<style scoped>
  .cost-contract {
    border-radius: 0px;
    border-left: solid 1px lightgrey;
    border-bottom: 0px;
    border-right: solid 1px lightgrey;
    border-top: 0px;
    font-size: 0.8rem;
  }
  .cost-input {
    border-radius: 0px;
    border-left: solid 1px lightgrey;
    border-bottom: 0px;
    border-right: 0px;
    border-top: 0px;
    background-color: lightyellow;
    font-size: 0.8rem;
    font-weight: 700;
    height: 1.7rem;
  }
  .cost-input-last {
    border-radius: 0px;
    border-left: solid 1px lightgrey;
    border-bottom: 0px;
    border-right: 0px;
    border-top: 0px;
    background-color: lightyellow;
    border-bottom-right-radius: 10px;
    font-size: 0.8rem;
  }
  .list-group .fee-border {
    border-left: solid 1px lightgray !important;
  }
</style>